import { BlankState, Text } from '@domain-group/suit-theme'

import ExplainerImage from '../../assets/explainer.png'

const CampaignSearchBlankState = () => (
  <BlankState
    boxProps={{
      marginTop: 'large',
    }}
    imageUrl={ExplainerImage}
    sidebar
  >
    <Text fontSize="small" letterSpacing="0.5px">
      To add a property stored in your CRM try searching for the address above. Select the property you would
      like to import from the list of available properties. If you don&apos;t see a property in the list,
      please check your CRM and ensure that the address entered matches.
    </Text>

    <Text fontSize="small" letterSpacing="0.5px" marginTop="large">
      <strong>You can change your CRM Sync details in Admin &gt; Integrations.</strong>
    </Text>
  </BlankState>
)

export default CampaignSearchBlankState
